import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowRightBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#234EEE"
      d="M12.53 7.55 4.48 1.263a.142.142 0 0 0-.23.112v1.38c0 .088.041.172.109.226L10.788 8l-6.43 5.019a.28.28 0 0 0-.108.225v1.38c0 .12.138.186.23.113l8.05-6.288a.57.57 0 0 0 0-.9"
    />
    <path
      stroke="#000"
      strokeOpacity={0.45}
      strokeWidth={0.001}
      d="M4.407 1.233a.14.14 0 0 1 .073.03l8.05 6.288a.57.57 0 0 1 0 .9l-8.05 6.286-.028.017a.1.1 0 0 1-.047.014.14.14 0 0 1-.106-.036.14.14 0 0 1-.048-.107v-1.38c0-.065.021-.13.061-.18l.047-.044L10.79 8l-.003-.002.002.001L4.36 2.98l-.046-.045a.3.3 0 0 1-.062-.18v-1.38a.14.14 0 0 1 .046-.105l.033-.023a.1.1 0 0 1 .038-.012.1.1 0 0 1 .04-.002Z"
    />
  </svg>
);
export default SvgArrowRightBlue;
